<template>
    <div class="local-data">
        <div class="filter-criteria">
            <div class="revenue-title">账号信息</div>
        </div>
        <div class="table-data">
            <div class="table-content">
                <a-tabs default-active-key="1">
                    <a-tab-pane key="1" tab="个人信息">
                        <div class="tab-content">
                            <div class="username-head">
                                <span>{{(userInfoData.name).substr(0, 1)}}</span>
                                <div class="username-info">
                                    <div>{{userInfoData.name}}</div>
                                    <div>{{userInfoData.id}}</div>
                                </div>
                            </div>
                            <div class="info-list">
                                <span class="info-title">姓名：</span>
                                <span v-if="ifShowName" class="info-content">{{userInfoData.name}}</span>
                                <a-input class="info-input" v-if="!ifShowName" v-model="username" />
                                <span v-if="ifShowName" @click="editName" class="info-operate">修改</span>
                                <span v-if="!ifShowName" @click="cancelName" class="info-operate">取消</span>
                                <span v-if="!ifShowName" @click="saveName" class="info-operate">保存</span>
                            </div>
                            <div class="info-list">
                                <span class="info-title">密码：</span>
                                <span v-if="ifShowPwd" class="info-content">******</span>
                                <a-input v-model="newPwd" placeholder="请输入新的密码" class="info-input" v-if="!ifShowPwd" />
                                <span v-if="ifShowPwd" @click="editPwd" class="info-operate">修改</span>
                                <span v-if="!ifShowPwd" @click="cancelPwd" class="info-operate">取消</span>
                                <span v-if="!ifShowPwd" @click="savePwd" class="info-operate">保存</span>
                            </div>
                            <div class="info-list">
                                <span class="info-title">部门：</span>
                                <span class="info-content">{{userInfoData.departmentName}}</span>
                            </div>
                             <div class="info-list">
                                <span class="info-title">角色：</span>
                                <span class="info-content">{{judgeRole(userInfoData.role)}}</span>
                            </div>
                             <div class="info-list">
                                <span class="info-title">月额度：</span>
                                <span class="info-content">{{userInfoData.monthQuota}}</span>
                            </div>
                             <div class="info-list">
                                <span class="info-title">本月剩余额度：</span>
                                <span class="info-content">{{userInfoData.leftQuota}}</span>
                            </div>
                             <div class="info-list">
                                <span class="info-title">注册时间：</span>
                                <span class="info-content">{{userInfoData.createTime}}</span>
                            </div>
                             <div class="info-list">
                                <span class="info-title">截止有效期：</span>
                                <span class="info-content">{{userInfoData.expirationTime}}</span>
                            </div>
                             <div class="info-list">
                                <span class="info-title">状态：</span>
                                <span class="info-content">{{userInfoData.statusName}}</span>
                            </div>
                             <div class="info-list">
                                <span class="info-title">最近在线时间：</span>
                                <span class="info-content">{{userInfoData.lastLoginTime}}</span>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="2" tab="公司信息" force-render>
                        <div class="tab-content">
                            <div class="username-head">
                                <img src="../../assets/img/company-logo.svg" alt="">
                                <div class="username-info">
                                    <div>企业版</div>
                                    <div>每月可领取线索{{consumptionData.companyMonthlyUsageAmount}}条</div>
                                </div>
                                <a-button @click="goToMiddleCenter">升级版本</a-button>
                            </div>
                            <div class="info-list">
                                <span class="info-title">公司名称：</span>
                                <span v-if="ifShowCompany" class="info-content">{{companyInfoData.name}}</span>
                                <a-input v-model="companyName" class="info-input" v-if="!ifShowCompany" />
                                <span v-if="ifShowCompany" @click="editCompany" class="info-operate">修改</span>
                                <span v-if="!ifShowCompany" @click="cancelCompany" class="info-operate">取消</span>
                                <span v-if="!ifShowCompany" @click="saveCompany" class="info-operate">保存</span>
                            </div>
                            <div class="info-list">
                                <span class="info-title">负责人：</span>
                                <span v-if="ifShowChargePerson" class="info-content">{{companyInfoData.commander}}</span>
                                <a-input v-model="personInCharge" class="info-input" v-if="!ifShowChargePerson" />
                                <span v-if="ifShowChargePerson" @click="editChargePerson" class="info-operate">修改</span>
                                <span v-if="!ifShowChargePerson" @click="cancelChargePerson" class="info-operate">取消</span>
                                <span v-if="!ifShowChargePerson" @click="saveChargePerson" class="info-operate">保存</span>
                            </div>
                            <div class="info-list">
                                <span class="info-title">联系方式：</span>
                                <span v-if="ifShowContactWay" class="info-content">{{companyInfoData.contactInformation}}</span>
                                <a-input v-model="contactPhone" class="info-input" v-if="!ifShowContactWay" />
                                <span v-if="ifShowContactWay" @click="editContactWay" class="info-operate">修改</span>
                                <span v-if="!ifShowContactWay" @click="cancelContactWay" class="info-operate">取消</span>
                                <span v-if="!ifShowContactWay" @click="saveContactWay" class="info-operate">保存</span>
                            </div>
                            <div class="info-list">
                                <span class="info-title">员工数：</span>
                                <span class="info-content">{{companyInfoData.userCount}}</span>
                            </div>
                            <div class="info-list">
                                <span class="info-title">开通时间：</span>
                                <span class="info-content">{{companyInfoData.createTime}}</span>
                            </div>
                            <div class="info-list">
                                <span class="info-title">到期时间：</span>
                                <span class="info-content">{{companyInfoData.expirationTime}}</span>
                            </div>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MonthBill',
        data() {
            return {
                ifShowName: true,
                ifShowPwd: true,
                ifShowCompany: true,
                ifShowChargePerson: true,
                ifShowContactWay: true,
                userInfoData: '',
                companyInfoData: '',
                consumptionData: '',
                username: '',
                newPwd: '',
                companyName: '',
                personInCharge: '',
                contactPhone: ''
            }   
        },
        methods: {
            editName() {
                this.ifShowName = false
                this.username = this.userInfoData.name
            },
            saveName() {
                this.ifShowName = true
                this.axios.post('/api/user/updateName', {
                    name: this.username,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryUserInfo()
                        this.$emit('fatherMethod')
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            editPwd() {
                this.ifShowPwd = false
                this.newPwd = ''
            },
            savePwd() {
                this.ifShowPwd = true
                this.axios.post('/api/user/updatePwd', {
                    password: this.newPwd,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryUserInfo()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            editCompany() {
                this.ifShowCompany = false
                this.companyName = this.companyInfoData.name
            },
            saveCompany() {
                this.ifShowCompany = true
                this.axios.post('/api/enterprise/updateName', {
                    name: this.companyName,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryCompanyInfo()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            editChargePerson() {
                this.ifShowChargePerson = false
                this.personInCharge = this.companyInfoData.commander
            },
            saveChargePerson() {
                this.ifShowChargePerson = true
                this.axios.post('/api/enterprise/updateCommander', {
                    commander: this.personInCharge,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryCompanyInfo()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            editContactWay() {
                this.ifShowContactWay = false
                this.contactPhone = this.companyInfoData.contactInformation
            },
            saveContactWay() {
                this.ifShowContactWay = true
                this.axios.post('/api/enterprise/updateContactInformation', {
                    contactInformation: this.contactPhone,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('修改成功')
                        this.queryCompanyInfo()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            },
            judgeRole(data) {
                switch (data){
                    case 1:
                        return '管理员'
                    case 2:
                        return '高级员工'
                    default :
                        return '普通员工'
                }
            },
            queryUserInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/user', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.userInfoData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryCompanyInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/enterprise', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.companyInfoData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryUseInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/externalInterface/queryDosage', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.consumptionData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            goToMiddleCenter() {
                let host = window.location.host
                this.axios(
                    {
                        method:'get',
                        url:'/api/intelligence/superLoginUrl', 
                        params: {
                            hostName: host
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        let url = response.data.data.superLoginUrl
                        window.location.href = url 
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error);
                })
            },
            cancelName() {
                this.ifShowName = true
            },
            cancelPwd() {
                this.ifShowPwd = true
            },
            cancelCompany() {
                this.ifShowCompany = true
            },
            cancelChargePerson() {
                this.ifShowChargePerson = true
            },
            cancelContactWay() {
                this.ifShowContactWay = true
            },
        },
        mounted: function() {
            this.queryUserInfo()
            this.queryCompanyInfo()
            this.queryUseInfo()
        }
    }
</script>

<style scoped lang="less">
    .local-data{
        height: 100%;
        display: flex;
        flex-direction: column;
        .filter-criteria{
            height: 54px;
            background: #fff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            margin-top: 1px;
            padding: 15px 24px;
            .revenue-title{
                color: rgba(0, 0, 0, 0.7);
                font-size: 14px;
            }
        }
        .table-data{
            flex: 1;
            padding: 24px;
            .table-content{
                width: 100%;
                height: 100%;
                background: #fff;
                padding: 12px 7px;
                .tab-content{
                    padding: 20px 16px;
                    .username-head{
                        height: 92px;
                        border-bottom: 1px dotted rgba(217, 217, 217, 1);
                        span{
                            display: inline-block;
                            width: 64px;
                            height: 64px;
                            line-height: 64px;
                            text-align: center;
                            border-radius: 32px;
                            color: rgba(255, 255, 255, 1);
                            font-size: 16px;
                            background: rgba(34, 215, 187, 1);
                            float: left;
                        }
                        .username-info{
                            display: inline-block;
                            margin-left: 16px;
                            float: left;
                            div:nth-child(1){
                                color: rgba(0, 0, 0, 1);
                                font-size: 16px;
                                font-weight: bold;
                                margin-top: 4px;
                            }
                            div:nth-child(2){
                                color: rgba(169, 169, 169, 1);
                                font-size: 12px;
                                margin-top: 2px;
                            }
                        }
                        img{
                            width: 56px;
                            float: left;
                        }
                        button{
                            margin-left: 116px;
                            float: left;
                            margin-top: 10px;
                        }
                    }
                    .info-list{
                        padding: 12px 0;
                        height: 50px;
                        line-height: 50px;
                        .info-title{
                            color: rgba(169, 169, 169, 1);
                            font-size: 14px;
                            display: inline-block;
                            width: 100px;
                        }
                        .info-content{
                            color: rgba(0, 0, 0, 1);
                            font-size: 14px;
                            display: inline-block;
                            width: 230px;
                        }
                        .info-input{
                            width: 210px;
                            margin-right: 20px;
                        }
                        .info-operate{
                            color: rgba(24, 144, 255, 1);
                            font-size: 14px;
                            cursor: pointer;
                            display: none;
                            margin-right: 8px;
                        }
                    }
                    .info-list:hover{
                        .info-operate{
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
</style>